module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/api-response/api-response.component.scss
// module id = ./src/app/api-response/api-response.component.scss
// module chunks = main